import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-patient-crm-wizard',
  templateUrl: './patient-crm-wizard.component.html',
  styleUrls: ['./patient-crm-wizard.component.css']
})
export class PatientCrmWizardComponent implements OnInit {

  canViewMedicalPatientInfo: boolean;
  patientId: number;

  constructor( private authService: AuthService,
               private route: ActivatedRoute ) {
  
  }

  async ngOnInit() {
    this.patientId = +this.route.snapshot.paramMap.get('Id'); 
    this.canViewMedicalPatientInfo = 
      await this.authService.canViewMedicalPatientInfo();
  }

  cancel() {
    history.back();
  }
}
